import { isEmpty } from "./commonHelper";

export function getAirportCity(IATACode, AirportsArray) {
  var val = "";
  const GetValue = () => {
    AirportsArray.forEach((v, i) => {
      if (v.IATAcode == IATACode) {
        if (isEmpty(v.AirportCity))
          val = v.AirportName
        else val = v.AirportCity
        return false;
      }
    });
  };
  GetValue();
  if (val === "") return IATACode;
  return val;
}

export function getFullAirportDetail(IATACode, AirportsArray) {
  var val = "";
  const GetValue = () => {
    AirportsArray.forEach((v, i) => {
      if (v.IATAcode == IATACode) {
        val = v.AirportName + " - " + v.Country
        return false;
      }
    });
  };
  GetValue();
  if (val === "") return IATACode;
  return val;
}

export function getAirportInfo(IATACode, AirportsArray) {
  if (!AirportsArray) return null;
  return AirportsArray.find(v => v.IATAcode === IATACode) || null;
}
